import * as yup from 'yup'

// eslint-disable-next-line max-len
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const loginSchema = yup.object().shape({
  contact: yup
    .string()
    .required('Contact is Required')
    .min(10, 'Please enter valid number')
    .max(10, 'Please enter correct number')
    .matches(phoneRegExp, 'Mobile number is not valid'),
  password: yup
    .string('Must be a string')
    .required('Password is Required')
    .min(4, 'Password is too short')
    .max(20, 'Password is too long'),
})

const signupSchema = yup.object().shape({
  contact: yup
    .string()
    .min(10, 'Please enter valid number')
    .max(10, 'Please enter correct number')
    .matches(phoneRegExp, 'Mobile number is not valid'),
  name: yup
    .string('Username must be a string')
    .min(4, 'Minimum 4 character is must')
    .max(20, 'Max 20 character')
    .required('firstname is Required'),
  email: yup
    .string()
    .email('Please enter a valid email'),
  username: yup
    .string('Must be a string')
    .required('Username is required')
    .min(4, 'Minimum 4 character is must'),
  password: yup
    .string('Must be a string')
    .required('Password is Required')
    .min(4, 'Password is too short')
    .max(20, 'Password is too long'),
  district: yup
    .string()
    .required('District is Required'),
})
export { loginSchema, signupSchema }
